import React, { useCallback } from 'react'
import { components } from 'react-select'
import classnames from 'classnames'

import { ReactComponent as CrossIcon } from '../../../assets/icons/close.svg'

import ButtonIcon from '../../../features/components/Buttons/ButtonIcon'

import { useStyles } from '../styles'

const SelectIndicatorsContainer = props => {
  const { showClearInputIcon, onClearInput, indicatorsClassName } = props.selectProps

  const handleClear = useCallback(
    e => {
      e.stopPropagation()
      onClearInput(e)
    },
    [onClearInput]
  )

  const classes = useStyles()

  // added onTouchEnd for custom icon, because item is not clickable on mobile due to known library issue
  return (
    <div className={classnames(classes.indicatorsWrapper, indicatorsClassName)}>
      {showClearInputIcon && (
        <ButtonIcon
          Icon={CrossIcon}
          className={classes.clearInputButton}
          iconClass={classes.clearInputIcon}
          onClick={handleClear}
          onTouchEnd={handleClear}
        />
      )}
      <components.IndicatorsContainer {...props} />
    </div>
  )
}

export default SelectIndicatorsContainer
